import infoSorting from '../InfoSorting/infoSorting.vue'
import inputCosts from '../InputCosts/inputCosts.vue'
import technicalVisit from '../technicalvisit/technicalvisit.vue'
import logOcurrence from '../logOcorrence/logOcurrence.vue'
import documentoccourences from '../documentoccourences/documentoccourences.vue'
import OcurrenceRepository from '@/shared/http/repositories/realestate/ocurrence'
import { loading } from '@/shared/utils/UIHelper'
import VueHtml2pdf from 'vue-html2pdf'
import ratingCustomer from '../ratingCustomer/ratingCustomer.vue'
import Roles from '@/shared/utils/roles.js'
import PermissionMixin from '@/store/module/permission/mixin'
import AccountMixin from '@/store/module/account/mixin'
import CompanyMixin from '@/store/module/company/mixin'

export default {
  components: {infoSorting, inputCosts, technicalVisit, logOcurrence, documentoccourences, VueHtml2pdf, ratingCustomer},
  mixins: [ AccountMixin, CompanyMixin, PermissionMixin ],
  props: ['dataDetails', 'statusOcorencia', 'refreshLog'],
  name: 'detailsOcurrence',
  data () {
    return {
      tabIndexCall: 0,
      dataDetailsPdf: {},
      technicalvisit: false,
      flagpdfview: false,
      tipo: null,
      logtab: false,
      campoUnidade: '',
      variavelaba: 0,
      roles: Roles
    }
  },
  mounted () {
    this.getInfoPdf()
    this.goToTabsByStatus()
  },
  watch: {
    tabIndexCall (newvalue) {
      if (newvalue === 4) {
        this.$refs['logOcurrence'].getLogById(this.dataDetails)
      }
    },
    statusOcorencia (newValue) {
      this.$nextTick(() => {
        if (this.$refs['logOcurrence']) {
          this.$refs['logOcurrence'].getLogById(this.dataDetails)
        }
      })
    }
  },
  methods: {
    edit () {
    },
    NextStatus () {
      loading.push()
      OcurrenceRepository.NextStatus(this.dataDetails.id)
        .then((Response) => {
          loading.pop()
          this.dataDetails.statusOcorrencia = Response.data
        })
        .catch((Error) => {
          loading.pop()
        })
    },
    onProgress (event) {
      console.log(`Processed: ${event} / 100`)
    },
    hasGenerated () {
      alert('PDF generated successfully!')
    },
    getInfoPdf () {
      loading.push()
      OcurrenceRepository.GetInfoPdf(this.dataDetails.id)
        .then((Response) => {
          this.dataDetailsPdf = Response.data
          for (let i = 0; i <= 11; i++) {
            const checkbox = document.getElementById('check-patologia-' + i)
            if (checkbox !== null) {
              checkbox.checked = false
            }
          }

          // Depois: marcar somente os patologiaInt do array
          for (let i = 0; i < this.dataDetailsPdf.patologia.length; i++) {
            const patologiaInt = parseInt(this.dataDetailsPdf.patologia[i].patalogiaInt)
            const checkbox = document.getElementById('check-patologia-' + patologiaInt)

            console.log('Ativando:', 'check-patologia-' + patologiaInt)

            if (checkbox !== null) {
              checkbox.checked = true
            }
          }

          loading.pop()
          if (this.flagpdfview) this.generatePDF()
          this.flagpdfview = true
        })
        .catch((Error) => {
          loading.pop()
        })
    },

    TipoUnidadeEmpreendimentos (tipo) {
      if (tipo !== null || tipo !== undefined) {
        if (tipo === 0) {
          this.campoUnidade = 'Unidade'
        } else if (tipo === 1) {
          this.campoUnidade = 'Lote'
        } else {
          this.campoUnidade = 'Casa'
        }
      }
    },

    formatHours (hour) {
      if (!hour.toString().includes('.')) {
        return hour.toString() + ':00'
      } else {
        return hour.toString().replace('.', ':') + '0'
      }
    },
    generatePDF () {
      this.$refs.html2Pdf.generatePdf()
    },
    async abrirNovaGuia ({ html2pdf, options, pdfContent }) {
      await html2pdf().set(options).from(pdfContent).toPdf().get('pdf').save()
    },

    changesTabs (novoValor) {
      this.$emit('refreshResumo', true)
      this.tabIndexCall = novoValor
    },
    goToTabsByStatus () {
      if (this.dataDetails.statusOcorencia === 1) {
        this.tabIndexCall = this.dataDetails.statusOcorencia
      }
      if (this.dataDetails.statusOcorencia === 2) {
        this.tabIndexCall = this.dataDetails.statusOcorencia
      }
      if (this.dataDetails.statusOcorencia === 3) {
        this.tabIndexCall = this.dataDetails.statusOcorencia
      }
      if (this.dataDetails.statusOcorencia === -1) {
        this.tabIndexCall = 3
      }
    },
    resumo (value) {
      this.technicalvisit = value
      this.$emit('teste', this.technicalvisit)
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/realestate/ocurrence/components/ocurrenceDetails/detailsOcurrence.js